import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSortedFollowingPicks} from 'selectors/followingPicks';
import Pick from 'components/Cards/Pick';

import './followingPicks.scss';

const FollowingPicks = ({followingPicks}) => (
  <React.Fragment>
    <div className="following-picks-title">Picks based on strategy you are following.</div>
    {followingPicks.length ? (
      followingPicks.map(pick => <Pick key={pick.id} pick={pick} />)
    ) : (
      <div className="message">
        Go ahead and <Link to="/strategies">Follow</Link> your first strategy!
      </div>
    )}
  </React.Fragment>
);

FollowingPicks.propTypes = {};

export default connect(state => ({
  followingPicks: getSortedFollowingPicks(state),
}))(FollowingPicks);
